"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageUploadWithCropping_1 = require("./ImageUploadWithCropping");
(function (w, $) {
    if (!$)
        return false;
    var imageUploadWithCroppingExtensions = {
        imageUploadWithCropping: function () {
            return this.each(function () {
                var obj = $(this);
                new ImageUploadWithCropping_1.ImageUploadWithCropping(obj);
            });
        }
    };
    $.fn.extend(imageUploadWithCroppingExtensions);
})(window, $);
